import { format } from 'date-fns';
const dateFormat = 'dd MMM yyyy';

export const formatData = (data) => {
  const cleanData = [];

  data.forEach((data) => {
    let hours = data.roundedtime / 60;
    let date = format(new Date(data.checkin), 'MM/dd');
    cleanData.push({ date: date, hours: hours });
  });

  return cleanData;
};

export const getDates = (data) => {
  const dates = [];

  data.forEach((data) => {
    dates.push(format(new Date(data.checkin), dateFormat));
  });

  return dates;
};

export const getOverallTotal = (data) => {
  let total = 0;

  data.forEach((data) => {
    let hours = data.roundedtime / 60;
    total += Math.floor(hours * 1000) / 1000;
  });

  return total;
};

export const computeTotalHours = (data) => {
  const combinedData = Object.values(
    data.reduce((obj, item) => {
      var key = item.date;

      if (!obj[key]) {
        obj[key] = Object.assign(item);
      } else {
        obj[key].hours += Math.floor(item.hours * 1000) / 1000;
      }
      obj[key].hours = Math.floor(Number(obj[key].hours) * 1000) / 1000;
      return obj;
    }, {})
  );

  return combinedData;
};

export const computeTotalHoursById = (data) => {
  const combinedHours = Object.values(
    data.reduce((obj, item) => {
      var key = item.empid;

      if (!obj[key]) {
        obj[key] = Object.assign(item);
      } else {
        obj[key].hours += Math.floor(item.hours * 1000) / 1000;
      }

      obj[key].hours = Math.floor(Number(obj[key].hours) * 1000) / 1000;

      return obj;
    }, {})
  );

  return combinedHours;
};
